import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  private loadingSource = new BehaviorSubject<boolean>(null);
  currentLoading = this.loadingSource.asObservable();

  counter: number = 0;

  constructor() { }

  changeCounter(x: number) {
    this.counter += x;
    if (this.counter > 0) {
      // setTimeout(() => {
      //   if (this.counter > 0) {
           this.loadingSource.next(true);        
      //   }
      // }, 1000);
    } else {
      this.loadingSource.next(false);
    }
  }

}
